"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UnlockOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M17 22.3V19a1 1 0 00-2 0v3.3a2 2 0 00-1 1.7 2 2 0 004 0 2 2 0 00-1-1.7z"/><path d="M25 14H11V8a4 4 0 014-4h2a4 4 0 014 4 1 1 0 002 0 6 6 0 00-6-6h-2a6 6 0 00-6 6v6H7a2 2 0 00-2 2v12a2 2 0 002 2h18a2 2 0 002-2V16a2 2 0 00-2-2zm0 14H7V16h18z"/>';
var UnlockOutlineSVG = function UnlockOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.UnlockOutlineSVG = UnlockOutlineSVG;
UnlockOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(UnlockOutlineSVG);
exports.default = _default;